import { WatchlistSearchParams, watchlist } from '@api/api/watchlist';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const fetchPublicLists = () => {
  return wretchRequest(watchlist.getPublicLists.path(), {
    schema: watchlist.getPublicLists.schema,
  });
};

export const searchWatchlists = (
  params: WatchlistSearchParams,
  signal?: AbortSignal
) =>
  apiFetch(watchlist.searchLists.path(params), {
    schema: watchlist.searchLists.schema,
    signal,
  });

interface FetchPublicListEntitiesParams {
  listId: string;
  signal?: AbortSignal;
}

export const fetchPublicListEntities = async ({
  listId,
  signal,
}: FetchPublicListEntitiesParams) => {
  return await wretchRequest(watchlist.getPublicListEntities.path(listId), {
    schema: watchlist.getPublicListEntities.schema,
    signal,
  });
};

export const safeFetchPublicListEntities = async ({
  listId,
  signal,
}: FetchPublicListEntitiesParams) => {
  return await apiFetch(watchlist.getPublicListEntities.path(listId), {
    schema: watchlist.getPublicListEntities.schema,
    signal,
  });
};
